import script from "./HomepageBeplanetSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageBeplanetSlider.vue?vue&type=script&setup=true&lang=js"

import "./HomepageBeplanetSlider.vue?vue&type=style&index=0&id=22d22b8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d22b8e"]])

export default __exports__